import {NetworkAPIVersion, NetworkParamType} from './network.utils';

export default {
  getResearchNotes: {
    url: 'api/research-notes/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
    params: {
      client_id: [NetworkParamType.string],
      author_id: [NetworkParamType.string],
      project_id: [NetworkParamType.string],
      tags: [NetworkParamType.string],
      offset: [NetworkParamType.number],
      limit: [NetworkParamType.number],
    },
  },
  getResearchNotesOptions: {
    url: 'api/research-notes/options/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
    params: {
      client_id: [NetworkParamType.string],
      member_id: [NetworkParamType.string],
    },
  },
  getResearchMembers: {
    url: 'api/research-members/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
    params: {
      member_id: [NetworkParamType.string],
      active: [NetworkParamType.number],
    },
  },
  searchResearchMembers: {
    url: 'api/research-members/search/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
    params: {
      query: [NetworkParamType.string],
    },
  },
  createResearchMember: {
    url: 'api/research-members/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: {
      member_id: [NetworkParamType.string],
      research_client_id: [NetworkParamType.string],
      status: [NetworkParamType.string],
    },
  },
  updateResearchMember: {
    url: 'api/research-members/{id}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'put',
    params: {
      member_id: [NetworkParamType.string],
      research_client_id: [NetworkParamType.string],
      status: [NetworkParamType.string],
    },
  },
  deleteResearchMember: {
    url: 'api/research-members/{id}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'delete',
  },
  searchResearchClients: {
    url: 'api/research-clients/search/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    autoCancel: true,
    params: {
      query: [NetworkParamType.string],
    },
  },
  getResearchClient: {
    url: 'api/research-clients/{id}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
  },
  getResearchClientSharepointFiles: {
    url: 'api/research-clients/{id}/sharepoint-files/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
  },
  getResearchClientSharepointFolderOptions: {
    url: 'api/research-clients/{id}/sharepoint-folder-options/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
  },
  saveResearchClientSharepointFolderOption: {
    url: 'api/research-clients/{id}/sharepoint-folder-options/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: {
      sharepoint_folder: [NetworkParamType.string],
    },
  },
  getResearchClientArchiveFiles: {
    url: 'api/research-clients/{id}/archive-files/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    params: {
      prefix: [NetworkParamType.string],
    },
  },
  getResearchClientArchiveFolderOptions: {
    url: 'api/research-clients/{id}/archive-folder-options/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
  },
  getResearchArchiveExplore: {
    url: 'api/research-clients/archive-explore/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    params: {
      prefix: [NetworkParamType.string],
    },
  },
  getResearchClientArchiveSuggestions: {
    url: 'api/research-clients/{id}/archive-suggestions/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
  },
  saveResearchClientArchiveFolderOption: {
    url: 'api/research-clients/{id}/archive-folder-options/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: {
      archive_folder: [NetworkParamType.string],
    },
  },
  getResearchClientArchiveFileDownloadUrl: {
    url: 'api/research-clients/{id}/archive-files/download/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    params: {
      archive_key: [NetworkParamType.string],
    },
  },
  bulkActionResearchClientArchiveFiles: {
    url: 'api/research-clients/{id}/archive-files/bulk-action/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: {
      action: [NetworkParamType.string],
      project_id: [NetworkParamType.string],
      files: [NetworkParamType.array],
    },
  },
  getResearchClientArchiveFilesBulkActionStatus: {
    url: 'api/research-clients/{id}/archive-files/bulk-action-status/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    params: {
      task_id: [NetworkParamType.string],
    },
  },
  bulkActionResearchClientSharepointFiles: {
    url: 'api/research-clients/{id}/sharepoint-files/bulk-action/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: {
      action: [NetworkParamType.string],
      files: [NetworkParamType.array],
    },
  },
  getResearchClientSharepointFilesBulkActionStatus: {
    url: 'api/research-clients/{id}/sharepoint-files/bulk-action-status/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    params: {
      task_id: [NetworkParamType.string],
    },
  },
  createResearchClient: {
    url: 'api/research-clients/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: {
      member_id: [NetworkParamType.string],
    },
  },
  getResearchNote: {
    url: 'api/research-notes/{id}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
  },
  createResearchNote: {
    url: 'api/research-notes/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: {
      research_client_id: [NetworkParamType.string],
      title: [NetworkParamType.string],
      tags: [NetworkParamType.array],
      projects: [NetworkParamType.array],
      content: [NetworkParamType.string],
      content_json: [NetworkParamType.object],
      location: [NetworkParamType.object],
    },
  },
  updateResearchNote: {
    url: 'api/research-notes/{id}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'put',
    params: {
      title: [NetworkParamType.string],
      tags: [NetworkParamType.array],
      projects: [NetworkParamType.array],
      content: [NetworkParamType.string],
      content_json: [NetworkParamType.object],
      location: [NetworkParamType.object],
    },
  },
  bulkMoveResearchNotes: {
    url: 'api/research-notes/bulk_move/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: {
      note_ids: [NetworkParamType.array],
      research_client_id: [NetworkParamType.string],
      projects: [NetworkParamType.array],
    },
  },
  bulkTagResearchNotes: {
    url: 'api/research-notes/bulk_tag/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: {
      note_ids: [NetworkParamType.array],
      tags: [NetworkParamType.array],
    },
  },
  deleteResearchNote: {
    url: 'api/research-notes/{id}/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'delete',
  },
  uploadNoteAsset: {
    url: 'api/research-notes/{id}/upload_asset/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    multipart: true,
    params: {
      attachment: [NetworkParamType.file],
    },
  },
  uploadNoteAssetFromUrl: {
    url: 'api/research-notes/{id}/upload_asset_from_url/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'post',
    params: {
      url: [NetworkParamType.string],
    },
  },
  transcribeNoteAsset: {
    url: 'api/research-notes/assets/{assetId}/transcribe/',
    apiVersion: NetworkAPIVersion.noVersion,
    method: 'get',
    params: {
      assetId: [NetworkParamType.string],
    },
  },
};
